import { seo } from '../seo';
export { PrivacyPolicyPage as default } from '../../src/pages/Legal/PrivacyPolicyPage';
export const meta = () => seo('legal.privacyPolicy');
